<div class="wwd-sr">
  <div class="wwd-row">
    <div class="wwd-col wwd-sr__col">
      <div class="wwd-copy" [innerHTML]="'WHAT-WE-DO_INTRO' | translate"></div>
      <p class="wwd-copy wwd-intro__visit" [innerHTML]="'WHAT-WE-DO_VISIT' | translate"></p>
    </div>

    <div class="wwd-stats">
      <img class="wwd-stats__shape" src="assets/images/what-we-do/stats-callout.svg" alt="" aria-hidden="true" />
      <img class="wwd-stats__edge" src="assets/images/what-we-do/stats-callout-edge.svg" alt="" aria-hidden="true" />
      <div class="wwd-stats__text">
        <p class="wwd-stats__lead">{{ 'WHAT-WE-DO_STATS-LEAD' | translate }}</p>
        <p>{{ 'WHAT-WE-DO_STATS-NGOS' | translate }}</p>
        <p>{{ 'WHAT-WE-DO_STATS-COUNTRIES' | translate }}</p>
        <p>{{ 'WHAT-WE-DO_STATS-STATES' | translate }}</p>
      </div>
    </div>
  </div>

  <h2 class="wwd-heading">{{ 'WHAT-WE-DO_HOW-CAN-WE-HELP' | translate }}</h2>

  <section class="wwd-section" *ngFor="let section of sections">
    <div class="wwd-section__bar">
      <div class="wwd-section__bar-title">{{ section.titleKey | translate }}</div>
      <div class="wwd-section__bar-email"><span [innerHTML]="section.emailKey | translate"></span></div>
      <img class="wwd-section__bar-flag" src="assets/images/what-we-do/title-bar-flag.svg" alt="" aria-hidden="true" />
    </div>

    <div class="wwd-section__body">
      <div class="wwd-section__media">
        <img class="wwd-section__photo" [src]="section.photo" [alt]="section.photoAltKey | translate" />
        <img class="wwd-section__badge" [src]="section.badge" alt="" aria-hidden="true" />
      </div>
      <div class="wwd-list wwd-section__list" [innerHTML]="section.listKey | translate"></div>
    </div>
  </section>
</div>
